import { Injectable } from '@angular/core';
import { DistributorListDto } from '@common/generated-api/models/distributor-list-dto';
import { AdminDistributorsApiService } from '@common/generated-api/services/admin-distributors-api.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DistributorsService {
  constructor(private adminDistributorsApiService: AdminDistributorsApiService) {}

  searchDistributors(query: string, limit: number): Observable<DistributorListDto[]> {
    return this.adminDistributorsApiService
      .searchDistributors({
        body: {
          searchText: query,
          limit,
          offset: 0,
          sorting: [{ order: 'ASC', type: 'NAME' }],
        },
      })
      .pipe(
        map((data) => data.result.data),
        catchError(() => of([])),
      );
  }

  getDistributor(distributorId: number) {
    return this.adminDistributorsApiService.getDistributor({ distributorId }).pipe(map((data) => data.result));
  }
}
